import { useBillingMarkAcceptanceErrorAsViewedMutation } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useMarkAcceptanceErrorAsViewed = (refetch: () => Promise<unknown>) => {
  const [mutation, mutationResult] = useBillingMarkAcceptanceErrorAsViewedMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (companyId: string, acceptanceId: string) => {
    const result = await mutation({
      variables: { input: { companyId, acceptanceId } },
    });

    await refetch();

    return result.data?.result?.ok;
  };

  return { request, loading: mutationResult.loading };
};

export default useMarkAcceptanceErrorAsViewed;
